import React, { useCallback, useState } from "react";
import { Button, Popover, Stack, TextField } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import { getUTCDate } from "../../../services/manageOrderService";
import { getOrdersData, getSalesData} from "../../../services/dataValidationService";
import { openPopup } from "../../../stateManagement/actions/popupActions";
import "./CalenderFilter.css";
import { isGapMoreThanNDays } from "../../../utils/calenderUtils";

type DataType = 'orders' | 'sales';

interface CalenderFilterProps {
  id: string | undefined;
  open: boolean;
  anchorEl: HTMLButtonElement | null;
  setAnchorEl: React.Dispatch<React.SetStateAction<HTMLButtonElement | null>>;
  loginId: string;
  setData: (data: any) => void;
  dataType: DataType;
}

function CalenderFilter(props: CalenderFilterProps) {
  const [startDate, setStartDate] = useState<Dayjs>(dayjs());
  const [endDate, setEndDate] = useState<Dayjs>(dayjs());

  const isStartDateIsGreaterThanEndDate = (
    startDate: dayjs.Dayjs,
    endDate: dayjs.Dayjs
  ): boolean => {
    const diff = endDate.diff(startDate);
    return diff < 0;
  };

  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") || "{}");
  const validDateRange = ConfigDictionary.dateRangeConfig ?? 31;
  function canWeMakeRequest(): boolean {
    if (startDate && endDate && isGapMoreThanNDays(startDate, endDate,validDateRange)) {
      openPopup("Alert", `You can't select date range more than ${validDateRange} days!`);
      return false;
    }
    if (
      startDate &&
      endDate &&
      isStartDateIsGreaterThanEndDate(startDate, endDate)
    ) {
      openPopup("Alert", "To Date should be greater than from date.");
      return false;
    }
    return true;
  }

  const handleApply = async (): Promise<void> => {
    if (canWeMakeRequest()) {
      const start = getUTCDate(startDate, "start");
      const end = getUTCDate(endDate, "end");
      await fetchData(start, end);
      props.setAnchorEl(null);
    }
  };

  const handleClearAll = (): void => {
    const date = dayjs();
    const start = getUTCDate(date, "start");
    const end = getUTCDate(date, "end");
    setStartDate(date);
    setEndDate(date);
    fetchData(start, end);
  };

  const fetchData = async (startDate: string, endDate: string): Promise<void> => {
    try {
      let response;
      if (props.dataType === 'orders') {
        response = await getOrdersData(startDate, endDate, props.loginId);
      } else {
        response = await getSalesData(startDate, endDate, props.loginId);
      }
      props.setData(response.features);
    } catch (error) {
      console.error(`Error fetching ${props.dataType} data:`, error);
      openPopup("Error", `Error fetching ${props.dataType} data. Please try again.`);
    }
  };

  const handleClose = (): void => {
    props.setAnchorEl(null);
  };

  return (
    <Popover
      id={props.id}
      open={props.open}
      anchorEl={props.anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "center",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: "left",
      }}
    >
      <div className="order-date-picker">
        <Stack spacing={2.8} direction={"column"}>
          <LocalizationProvider dateAdapter={AdapterDayjs} className="dateEnter">
            <DatePicker
              label="From Date"
              inputFormat="DD-MM-YYYY"
              value={startDate}
              maxDate={dayjs()}
              onChange={(value) => {
                if (value) {
                  setStartDate(value);
                }
              }}
              renderInput={(props) => (
                <TextField {...props} disabled size="small" />
              )}
            />
          </LocalizationProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="To Date"
              inputFormat="DD-MM-YYYY"
              value={endDate}
              maxDate={dayjs()}
              onChange={(value) => {
                if (value) {
                  setEndDate(value);
                }
              }}
              renderInput={(props) => (
                <TextField {...props} disabled size="small" />
              )}
            />
          </LocalizationProvider>
        </Stack>
        <div
          className="reset-and-apply-button-manage-order"
          style={{ paddingTop: "4%" }}
        >
          <Button
            variant="contained"
            sx={{ backgroundColor: "#237C9D" }}
            onClick={handleApply}
          >
            Apply
          </Button>
          <Button
            variant="contained"
            sx={{ backgroundColor: "#237C9D" }}
            onClick={handleClearAll}
          >
            Reset
          </Button>
        </div>
      </div>
    </Popover>
  );
}

export default CalenderFilter;